import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'sample',
    templateUrl: './sample.component.html',
})
export class SampleComponent implements OnInit {

    constructor() {
    }

    ngOnInit() {
    }
}


// WEBPACK FOOTER //
// ./public/upgrade/feature/sample-v2/sample.component.ts